// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MessageImages_imageWrapper__xYdI5","image":"MessageImages_image__AfALV"};